import { TextField,Typography } from '@mui/material';
import { useContext,useEffect } from 'react';
import { WebFormContext } from '../../../../context/WebFormContext';
import { trackEventMatomo } from '../../../../helpers/matomo';
import { isValidCpfCnpjFormat, normalizeCpfCnpj } from '../../../../helpers/cpfCnpj';
import { SubItemFormFilling } from '../../../../types/new-form-filling/types';
import CheckIcon from '../../CheckIcon';
import AdditionalInfo from '../../Structure/AdditionalInfo';


type Props = {
  value: string | string[] | null;
  setValue: Function;
  subitem: SubItemFormFilling,
};

export class MaskHelper {
  static cpf(value: string) {
    return normalizeCpfCnpj(value)
      .replace(/[^\d]/g, "")
      .slice(0, 11)
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }

  static cnpj(value: string) {
    const document = normalizeCpfCnpj(value).slice(0, 14);
    const base = document.slice(0, 12);
    const checkDigits = document.slice(12).replace(/[^\d]/g, "");
    let formatted = base.slice(0, 2);

    if (base.length > 2) formatted += `.${base.slice(2, 5)}`;
    if (base.length > 5) formatted += `.${base.slice(5, 8)}`;
    if (base.length > 8) formatted += `/${base.slice(8, 12)}`;
    if (checkDigits) formatted += `-${checkDigits}`;

    return formatted;
  }

  static cpfCnpj(value: string) {
    const document = normalizeCpfCnpj(value);
    const isCnpj = /[A-Z]/.test(document) || document.length > 11;

    return isCnpj ? MaskHelper.cnpj(document) : MaskHelper.cpf(document);
  };

  static numberSubItemMask(value: string) {
    return value
      .replace(/[^-\d]/, '.')
      .replace(/^[^-\d]/, '')
      .replace(/(\d{1,})([^\d])/, '$1.')
      .replace(/(\d)(\W)(\W)/, '$1$2')
      .replace(/(\d)(\W)(\d{1,})(\W)/, '$1$2$3');
  };
}

export default function CpfCnpj({ subitem, value, setValue }: Props) {
  const { ForceUpdate } = useContext(WebFormContext);
  // const { t } = useTranslation('translation');

  const checkItem = () => {
    if (isValidCpfCnpjFormat(value as string)) {
      return (<AdditionalInfo subItem={subitem} />);
    }
  };

  useEffect(() => {
    if (subitem.ocorrencia) {
      setValue(subitem.ocorrencia);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (subitem.ocorrencia) return;
    if (subitem.padrao) {
      setValue(subitem.padrao);
      subitem.ocorrencia = subitem.padrao as string;
    }
    if (CheckIcon(subitem, value) === 'ok') {
      subitem.checked = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (CheckIcon(subitem, value) === 'ok') {
      subitem.checked = true;
    } else if (!value) {
      delete subitem.checked;
    }
    ForceUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);


  return (
    <>
      <Typography
        variant='h6'
        style={{
          wordBreak: 'break-all',
          marginBottom: '5px',
          width: '100%',
          textAlign: 'left'
        }}>
        {CheckIcon(subitem, value) === 'naoOk' && '*'}  {(subitem.id + 1)}
        - {subitem.nome}
      </Typography>
      <TextField
        style={{ backgroundColor: 'inherit' }}
        onClick={() => trackEventMatomo('seleciona documento', 'click', 'input', 'edita valor')}
        value={(value ?? '') as string}
        className={`${subitem.itemid}|${subitem.id}`}
        type="text"
        variant='outlined'
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          const newValue = MaskHelper.cpfCnpj(event.target.value);
          setValue(newValue);
          subitem.ocorrencia = newValue;
          if (!newValue?.length) {
            delete subitem.ocorrencia;
          }
        }}
      />
      {checkItem()}
    </>
  );
}
